import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded'
import { Card as CardBase } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  width: 100%;
`

export const GridContainer = styled(({ margin, minHeight, padding, width, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    padding: ${props => props.padding};
    width: ${props => props.width};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const JumboTitle = styled('h1')`
  color: ${props => props.theme.palette.brand.white};
  background-color: transparent;
  padding: 4px;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 40px;
  line-height: 32px;
  margin: 8px 0 0;

  ${props => props.theme.breakpoints.up('sm')} {
    margin: 57px 0 0;
  }
`
export const JumboDescription = styled('p')`
  display: inline-block;
  color: ${props => props.theme.palette.brand.white};
  background-color: transparent;
  padding: 4px;
  font-family: ${props => props.theme.typography.fontFamily};
  max-width: 50%;
  font-size: 18px;
  line-height: normal;
`
export const StarIcon = styled(StarRateRoundedIcon)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.custom.yellowStar};
    font-size: 24px;
    padding-bottom: 5px;
  }
`

export const Card = styled(CardBase)`
  &.MuiPaper-root {
    & > * {
      padding: 4px 10px 4px;
      color: ${props => props.theme.palette.charts.navyBlue};
      backgroundcolor: ${props => props.theme.palette.custom.pastelBlue};
      margin: 58px 0 0;
      width: 88px;
    }
  }
`
